<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="成本库">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="规格" />
          </template>
          <template #default="{ row }">
            <strong>{{ row.name }}</strong>
            <text class="ml-2 text-xs text-gray-400">
              {{ row.specification }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
          prop="remark"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <text>
              {{ row.d_cost_type_name + "-" + row.d_cost_type_pname }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="单位"
          prop="d_measure_unit_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="备注"
          prop="remark"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="状态" :width="70" fixed="right">
          <template #default="{ row }">
            <text v-if="row.status == 1" class="text-blue-500">启用</text>
            <text v-else class="text-red-500">停用</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}成本项`"
    class="c-el-dialog"
    width="400"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { costitem_page, costitem_delete } from "@/http/costitem";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      costitem_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(costitem_delete, row.id, onLoad, {
        filed: "客户",
        name: row.name,
      });
    };

    return { state, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
